import type { State } from './types';

export const initialState: State = {
	isLoading: false,
	conversation: null,
	searchAll: false,
	pipeline: '',
	isTesting: false,
	feedbackCollectorConfig: {
		isVisible: false,
		messageId: undefined,
	},
	activeTimer: null,
	ui: {
		conversationScrollBarWidth: '0px',
	},
};

export const ASSISTANT_USER_TYPE = 'assistant';

export const HELP_SEEKER_USER_TYPE = 'helpseeker';
